export const addHttpsIfNeeded = (value: string) =>
  value.startsWith('https://') || value.startsWith('http://')
    ? value
    : `https://${value}`
